import CldImg from './CldImg'

export default {
  name: 'OfferSliderCardUnit',
  components: { CldImg },
  template: `
    <div class="grid unit-card lightgallery">
      <div class="unit-card__image col-12 col-md-6">
        <div class="frame frame--bottom-right frame--hide-side-md-down">
          <a :href="offer.link" :title="offer.title">
            <CldImg :src="offer.image" :alt="offer.title" />
          </a>
        </div>
      </div>
      <div class="col-12 col-md-4 offset-md-1 unit-card__content offset-md-7">
        <a class="h3" :href="offer.link">{{ offer.title }}</a>
        <span v-if="offer.properties.length === 1" class="card__property">{{ offer.properties[0] }}</span>
        <span v-if="teaser" class="card__teaser no-margin">{{ teaser }}</span>
        <p>{{ offer.description }}</p>
        <div>
          <a :href="offer.link" class="button button--outline">{{ $t(buttonText) }}</a>
        </div>
      </div>
    </div>
  `,
  props: { offer: Object, teaser: String, buttonText: String, extraClasses: Array },
}
